/**
 * Product translation baseline promoted from the validated DEV customizations.
 * Keys remain flat so they can be applied consistently to the i18next catalog.
 */
export const baselineTranslations: Record<"fr" | "en", Record<string, string>> = {
  fr: {
    "dashboard.replenishment.title": "Réapprovisionnements",
    "dashboard.views.replenishment": "Réapprovisionnements",
    "documents.dictionary.fields.uom": "Unité",
    "documents.dictionary.fields.hu_uom": "Unité",
    "documents.dictionary.fields.result": "Résultat",
    "documents.dictionary.fields.control": "Valider",
    "inventory.selection.ABC.description": "Compter les articles ABC arrivés à échéance selon la fréquence configurée",
    "documents.dictionary.fields.asn_lines": "Numéro d'Article",
    "documents.dictionary.fields.hu_number": "Numéro UM",
    "documents.dictionary.fields.hu_status": "Status UM",
    "documents.dictionary.fields.lotNumber": "Lot",
    "documents.dictionary.fields.asn_number": "Numéro ASN",
    "documents.dictionary.fields.hu_barcode": "Code barre UM",
    "documents.dictionary.fields.lineNumber": "Ligne",
    "documents.dictionary.fields.asn_barcode": "Code Barre ASN",
    "documents.dictionary.fields.client_code": "Code Client",
    "documents.dictionary.fields.client_name": "Nom du Client",
    "documents.dictionary.fields.hu_quantity": "Quantité",
    "documents.dictionary.fields.information": "Référence",
    "documents.dictionary.fields.hu_lotNumber": "Lot",
    "documents.dictionary.fields.materialCode": "Article",
    "documents.dictionary.fields.materialName": "Description",
    "documents.dictionary.fields.source_trace": "Origine",
    "documents.dictionary.fields.material_code": "Article",
    "documents.dictionary.fields.material_name": "Description article",
    "documents.dictionary.fields.supplier_code": "Code fournisseur",
    "documents.dictionary.fields.supplier_name": "Nom du fournisseur",
    "documents.dictionary.fields.customs_broker": "Courtier en Douane",
    "documents.dictionary.fields.customs_checks": "Contrôles douanier",
    "documents.dictionary.fields.expirationDate": "Expiration",
    "documents.dictionary.fields.warehouse_code": "Code Entrepôt",
    "documents.dictionary.fields.customs_comment": "Commentaires",
    "documents.dictionary.fields.document_field1": "Référence source ASN",
    "documents.dictionary.fields.document_field2": "Client",
    "documents.dictionary.fields.document_field3": "Décision",
    "documents.dictionary.fields.document_number": "Numéro de document",
    "documents.dictionary.fields.hu_serialNumber": "Numéro de série",
    "documents.dictionary.fields.document_barcode": "Code bare",
    "documents.dictionary.fields.expectedQuantity": "Quantité attendue",
    "documents.dictionary.fields.hu_qualityStatus": "Status qualité",
    "documents.dictionary.fields.receivedQuantity": "Quantité reçue",
    "documents.dictionary.fields.source_asnNumber": "Source ASN",
    "documents.dictionary.fields.customs_reference": "Reference MRN",
    "documents.dictionary.fields.hu_trackingNumber": "Numéro de lot/série",
    "documents.dictionary.fields.hu_quantityDisplay": "Quantité et Unité",
    "documents.dictionary.fields.asn_expectedArrival": "Arrivée prévue",
    "documents.dictionary.fields.document_generatedAt": "Date de création",
    "documents.dictionary.fields.source_receiptNumber": "Réception source",
    "documents.dictionary.fields.asn_externalReference": "Référence Externe",
    "documents.dictionary.fields.asn_purchaseOrderNumber": "Numéro de Commande",
    "documents.dictionary.fields.asn_customsClearanceNumber": "Numéro Dédouanement",
    "documents.dictionary.fields.asn_customsClearanceStatus": "Etat du Dédouanement",
    "documents.dictionary.fields.asn_customsClearanceRequired": "Dédouanement requis"
  },
  en: {
    "dashboard.title": "Operational dashboard",
    "inbound.adHoc.title": "Create a spot receipt",
    "delivery.actions.take": "Start Task",
    "inbound.actions.adHoc": "Spot receipt",
    "stock.detail.nextExit": "NEXT OUTBOUND",
    "inbound.card.adHocMeta": "spot receipt · warehouse {{warehouse}} · reason {{reason}}",
    "dashboard.details.build": "Prepare",
    "delivery.diagnostics.take": "Start Mission",
    "masterData.clients.station": "Associated delivery station",
    "delivery.actions.confirmDrop": "Confirm delivery",
    "delivery.actions.confirmTake": "Confirm task",
    "delivery.help.scanTrolleyPou": "Scan the Trolley used, then the POU, to confirm the physical delivery",
    "dashboard.replenishment.title": "Replenishment",
    "dashboard.views.replenishment": "Replenishment",
    "preparation.actions.confirmTake": "Confirm task",
    "masterData.products.rotationTitle": "Outbound policy — {{code}}",
    "masterData.products.rotationAction": "Outbound policy",
    "configuration.transfers.description": "If a transition is enabled and stations differ, the next activity remains blocked until delivery is confirmed. Otherwise, the logical movement is immediate.",
    "inventory.selection.ABC.description": "Count ABC-classified materials that are due for inventory based on their configured frequency",
    "configuration.equipment.putawayCompletion": "at the end of the delivery or the tour",
    "configuration.equipment.deliveryCompletion": "after confirming delivery"
  }
};
